import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { LangCtx } from "../../../lib/context";
import "../Styles.css";
// const psl = require("psl");

const WebClinicSideNavLinks = (props) => {
    const location = useLocation();
    const { l } = useContext(LangCtx);

    return (
        <>
            <ul className="wsnGroup">
                {/* clinic links */}
                <li className="wsnItem">
                    <Link to="/clinic-dashboard" className={location.pathname === "/clinic-dashboard" ? "wsnLink wsnAcitve" : "wsnLink"}>
                        <img src="/images/icons/dashboard.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.dashboard}</span>
                        </div>
                    </Link>
                </li>
                {/* <li className="wsnItem">
                    <Link to="/clinic-report" onClick={props.hideMenu} className={location.pathname === "/clinic-report" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/dashboard.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>Reports</span>
                        </div>
                    </Link>
                </li> */}
                <li className="wsnItem">
                    <Link
                        to="/doctor-report"
                        onClick={props.hideMenu}
                        className={location.pathname === "/doctor-report" ? "wsnLink wsnAcitve" : "wsnLink"}
                    >
                        <img src="/images/icons/report.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.reports}</span>
                        </div>
                    </Link>
                </li>
                <li className="wsnItem">
                    <Link
                        to="/clinic-createusers"
                        onClick={props.hideMenu}
                        className={location.pathname === "/clinic-createusers" ? "wsnLink wsnAcitve" : "wsnLink"}
                    >
                        <img src="/images/icons/create-patient.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.create_user}</span>
                        </div>
                    </Link>
                </li>
                {/* <li className="wsnItem">
                    <Link to="/create-patient" className={location.pathname === "/create-patient" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/create-patient.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.cret_new_pat}</span>
                        </div>
                    </Link>
                </li> */}
                {/* <li className="wsnItem">
                    <Link to="/doctor-schedule" className={location.pathname === "/doctor-schedule" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/create-schedule-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.book_apptmnt}</span>
                        </div>
                    </Link>
                </li> */}
                {/* <li className="wsnItem">
                    <Link to="/patients-list" className={location.pathname === "/patients-list" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/patients-list.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.pat_list}</span>
                        </div>
                    </Link>
                </li> */}
                <li className="wsnItem">
                    <Link
                        to="/clinic-users"
                        onClick={props.hideMenu}
                        className={location.pathname === "/clinic-users" ? "wsnLink wsnAcitve" : "wsnLink"}
                    >
                        <img src="/images/icons/patients-list.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.users}</span>
                        </div>
                    </Link>
                </li>
                <li className="wsnItem">
                    <Link to="/appointments" className={location.pathname === "/appointments" ? "wsnLink wsnAcitve" : "wsnLink"}>
                        <img src="/images/icons/appointments-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.apptmnts}</span>
                        </div>
                    </Link>
                </li>
                <li className="wsnItem">
                    <Link to="/clinic-uploads" className={location.pathname === "/clinic-uploadss" ? "wsnLink wsnAcitve" : "wsnLink"}>
                        <img src="/images/icons/uploads-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.waiting_uploads}</span>
                        </div>
                    </Link>
                </li>
                <li className="wsnItem">
                    <Link
                        to="/clinic-config"
                        onClick={props.hideMenu}
                        className={location.pathname === "/clinic-config" ? "wsnLink wsnAcitve" : "wsnLink"}
                    >
                        <img src="/images/icons/analytics.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.configuration}</span>
                        </div>
                    </Link>
                </li>
            </ul>
        </>
    );
};

export default WebClinicSideNavLinks;
